<template>
  <label class="ai-visibility-search">
    <span class="ai-visibility-search__control">
      <i class="material-icons">search</i>
      <input
        type="search"
        :value="value"
        :placeholder="placeholder"
        :aria-label="ariaLabel || placeholder"
        :disabled="disabled"
        @input="$emit('input', $event.target.value)"
      />
      <button
        v-if="value"
        type="button"
        :disabled="disabled"
        aria-label="Clear search"
        @click="clear"
      >
        <i class="material-icons">close</i>
      </button>
    </span>
  </label>
</template>

<script>
export default {
  name: 'AiVisibilitySearchInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Search',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: '',
    },
  },
  methods: {
    clear () {
      this.$emit('input', '')
      this.$emit('clear')
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-search {
  display: inline-flex;
  min-width: 220px;
}

.ai-visibility-search__control {
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
}

.ai-visibility-search__control > i {
  position: absolute;
  right: 12px;
  color: #2C2C2C;
  font-size: 20px;
  pointer-events: none;
}

.ai-visibility-search input {
  width: 100%;
  height: 42px;
  border: 1px solid var(--v-gray13Color-base);
  border-radius: 6px;
  background: var(--v-cardBg-base);
  color: var(--v-mainColor-base);
  font-size: 14px;
  padding: 0 38px 0 10px;
  font-weight: 600;
}

.ai-visibility-search input:focus {
  border-color: var(--v-profileAnchorColor-base);
  outline: 2px solid var(--v-lightYellowColor-base);
  outline-offset: 1px;
}

.ai-visibility-search button {
  position: absolute;
  right: 30px;
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #2C2C2C;
  cursor: pointer;
  padding: 0;
}

.ai-visibility-search button:focus {
  outline: 2px solid var(--v-lightYellowColor-base);
}

.ai-visibility-search button i {
  font-size: 18px;
}
</style>
